import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user ID from parameters

        // Form for user state management
        const estado_usuario = {
            view: 'form',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            id: 'estadoUsuario',
            rows: [
                { view: 'label', label: _('Estado de Usuario') }, // Label for user state
                {
                    css: 'centrar',
                    id: 'StateSwith', // Switch for user activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for user state switch
                        if ($$('StateSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for contingency state management
        const estado_contingencia = {
            view: 'form',
            id: 'Contingency',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia') }, // Label for contingency state
                {
                    id: 'StateContingencySwith', // Switch for contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for contingency state switch
                        if ($$('StateContingencySwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencySwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencySwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for sports contingency state management
        const estado_contingenciaDeportivas = {
            view: 'form',
            id: 'ContingencyDeportivas',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Deportivas') }, // Label for sports contingency state
                {
                    id: 'StateContingencyDeportivasSwith', // Switch for sports contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for sports contingency state switch
                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyDeportivasSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyDeportivasSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for casino contingency state management
        const estado_contingenciaCasino = {
            view: 'form',
            id: 'ContingencyCasino',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino') }, // Label for casino contingency state
                {
                    id: 'StateContingencyCasinoSwith', // Switch for casino contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for casino contingency state switch
                        if ($$('StateContingencyCasinoSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyCasinoSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyCasinoSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for live casino contingency state management
        const estado_contingenciaCasinoVivo = {
            view: 'form',
            id: 'ContingencyCasinoVivo',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino en Vivo ') }, // Label for live casino contingency state
                {
                    id: 'StateContingencyCasinoVivoSwith', // Switch for live casino contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for live casino contingency state switch
                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for virtual contingency state management
        const estado_contingenciaVirtuales = {
            view: 'form',
            id: 'ContingencyVirtuales',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Virtuales') }, // Label for virtual contingency state
                {
                    id: 'StateContingencyVirtualesSwith', // Switch for virtual contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for virtual contingency state switch
                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyVirtualesSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyVirtualesSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for poker contingency state management
        const estado_contingenciaPoker = {
            view: 'form',
            id: 'ContingencyPoker',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Poker') }, // Label for poker contingency state
                {
                    id: 'StateContingencyPokerSwith', // Switch for poker contingency activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for poker contingency state switch
                        if ($$('StateContingencyPokerSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyPokerSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateContingencyPokerSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for user registration state management
        const estado_registroUsuario = {
            view: 'form',
            id: 'RegistroUsuario',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Registro del Usuario') }, // Label for user registration state
                {
                    id: 'StateRegistroUsuarioSwith', // Switch for user registration activation state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Label when switch is on
                    offLabel: _('Inactivo'), // Label when switch is off
                    click: () => {
                        // Click event handler for user registration state switch
                        if ($$('StateRegistroUsuarioSwith').getValue() == 1) {
                            // If switch is turned on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"RegistroUsuario","Id":' + cur_user + ',"IsActivate":"A"}', // JSON payload for activation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateRegistroUsuarioSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is turned off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for AJAX request
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"RegistroUsuario","Id":' + cur_user + ',"IsActivate":"I"}', // JSON payload for deactivation
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message on success
                                            );
                                            $$('StateRegistroUsuarioSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Return the main layout configuration
        return {
            id: 'a5',
            height: 600,
            rows: [
                {
                    responsive: 'a5',
                    cols: [
                        estado_usuario,
                        estado_contingencia,
                        estado_contingenciaDeportivas,
                        estado_contingenciaCasino,
                    ],
                },
                {
                    responsive: 'a5',
                    cols: [
                        estado_contingenciaCasinoVivo,
                        estado_contingenciaVirtuales,
                        estado_contingenciaPoker,
                        estado_registroUsuario,
                        { gravity: 1, minWidth: 10 }, // Spacer
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches user data.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user ID from parameters
        webix.html.addStyle(
            '.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }', // Style for red background
        );
        webix.html.addStyle(
            '.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }', // Style for green background
        );
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientById',
            'id=' + cur_user, // Fetch user data by ID
            {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse the response text
                    // Set switch values based on user data
                    if (text[0].IsActivate == 'A') {
                        $$('StateSwith').setValue(1); // Set user state switch to on
                    } else {
                        $$('StateSwith').setValue(0); // Set user state switch to off
                    }
                    if (text[0].IsActivateContingency == 'A') {
                        $$('StateContingencySwith').setValue(1); // Set contingency state switch to on
                    } else {
                        $$('StateContingencySwith').setValue(0); // Set contingency state switch to off
                    }
                    if (text[0].IsActivateContingencyDeportivas == 'A') {
                        $$('StateContingencyDeportivasSwith').setValue(1); // Set sports contingency switch to on
                    } else {
                        $$('StateContingencyDeportivasSwith').setValue(0); // Set sports contingency switch to off
                    }
                    if (text[0].IsActivateContingencyCasino == 'A') {
                        $$('StateContingencyCasinoSwith').setValue(1); // Set casino contingency switch to on
                    } else {
                        $$('StateContingencyCasinoSwith').setValue(0); // Set casino contingency switch to off
                    }
                    if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                        $$('StateContingencyCasinoVivoSwith').setValue(1); // Set live casino contingency switch to on
                    } else {
                        $$('StateContingencyCasinoVivoSwith').setValue(0); // Set live casino contingency switch to off
                    }
                    if (text[0].IsActivateContingencyVirtuales == 'A') {
                        $$('StateContingencyVirtualesSwith').setValue(1); // Set virtual contingency switch to on
                    } else {
                        $$('StateContingencyVirtualesSwith').setValue(0); // Set virtual contingency switch to off
                    }
                    if (text[0].IsActivateContingencyPoker == 'A') {
                        $$('StateContingencyPokerSwith').setValue(1); // Set poker contingency switch to on
                    } else {
                        $$('StateContingencyPokerSwith').setValue(0); // Set poker contingency switch to off
                    }
                    if (text[0].IsActivateRegistroUsuario == 'A') {
                        $$('StateRegistroUsuarioSwith').setValue(1); // Set user registration switch to on
                    } else {
                        $$('StateRegistroUsuarioSwith').setValue(0); // Set user registration switch to off
                    }
                    ContingencyVirtuales; // Placeholder for future use
                    console.log(text); // Log the user data for debugging
                },
            },
        );
    }
}

// FILE DOCUMENTED
